"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
const useStyles = (props, isTransitionInMotion, isExpanded, isOpenBtnVisible) => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem,
    scrollProps
  } = (0, _hooks.useStylesUtils)();
  const {
    items = [],
    itemHeight = 0
  } = props;
  const ccExpandableListStyle = (0, _react.useMemo)(() => {
    const itemsProps = () => {
      const maxHeight = isExpanded ? pxToRem(itemHeight * 3 + 16) : items.length > 0 ? pxToRem(itemHeight + 16) : 0;
      const padding = items.length > 0 ? `${pxToRem(8)} ${pxToRem(16)} ${pxToRem(isTransitionInMotion || isExpanded && !isMobileView ? 40 : 8)}` : `0 ${pxToRem(16)}`;
      const marginBottom = items.length > 0 ? pxToRem(10) : 0;
      return {
        maxHeight,
        padding,
        marginBottom
      };
    };
    const expandedProps = () => {
      const overflow = isExpanded && !isTransitionInMotion ? 'auto' : 'hidden';
      const maxHeight = isExpanded ? pxToRem(itemHeight * 3) : items.length > 0 ? pxToRem(itemHeight) : 0;
      return {
        overflow,
        maxHeight
      };
    };
    const openBtnExpandedProps = () => {
      const marginInlineEnd = isExpanded ? pxToRem(-72) : 0;
      const opacity = isOpenBtnVisible && !isExpanded ? 1 : 0;
      return {
        marginInlineEnd,
        opacity
      };
    };
    const closeBtnExpandedProps = () => {
      const opacity = isExpanded ? 1 : 0;
      return {
        opacity
      };
    };
    const ccExpandableList = (0, _css.css)({
      position: 'relative',
      overflow: 'hidden',
      borderRadius: pxToRem(10),
      background: themeColors?.basic.light,
      transition: '.5s ease-in-out',
      boxSizing: 'content-box',
      ...itemsProps()
    });
    const ccExpandableListContent = (0, _css.css)({
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    });
    const ccExpandableListItems = (0, _css.css)({
      padding: 0,
      margin: 0,
      listStyle: 'none',
      overflow: 'hidden',
      display: 'flex',
      flexWrap: 'wrap',
      transition: '.5s ease-in-out',
      ...expandedProps(),
      ...scrollProps()
    });
    const ccExpandableListItem = (0, _css.css)({
      position: 'relative'
    });
    const ccExpandableListRemoveAll = (0, _css.css)({
      marginInlineStart: pxToRem(8)
    });
    const ccExpandableListOpen = (0, _css.css)({
      whiteSpace: 'nowrap',
      transition: '0.5s ease-in-out',
      ...openBtnExpandedProps()
    });
    const ccExpandableListClose = (0, _css.css)({
      position: 'absolute',
      bottom: pxToRem(12),
      left: '50%',
      transform: 'translateX(-50%)',
      transition: '0.5s ease-in-out',
      ...closeBtnExpandedProps()
    });
    const ccExpandableListBtn = (0, _css.css)({
      fontWeight: 'bold'
    });
    return {
      ccExpandableList,
      ccExpandableListContent,
      ccExpandableListItems,
      ccExpandableListItem,
      ccExpandableListRemoveAll,
      ccExpandableListOpen,
      ccExpandableListClose,
      ccExpandableListBtn
    };
  }, [isExpanded, isMobileView, isOpenBtnVisible, isTransitionInMotion, itemHeight, items.length, pxToRem, scrollProps, themeColors?.basic.light]);
  return {
    'cc-ExpandableList': ccExpandableListStyle.ccExpandableList,
    'cc-ExpandableList__content': ccExpandableListStyle.ccExpandableListContent,
    'cc-ExpandableList__items': ccExpandableListStyle.ccExpandableListItems,
    'cc-ExpandableList__item': ccExpandableListStyle.ccExpandableListItem,
    'cc-ExpandableList__remove-all': ccExpandableListStyle.ccExpandableListRemoveAll,
    'cc-ExpandableList__open': ccExpandableListStyle.ccExpandableListOpen,
    'cc-ExpandableList__close': ccExpandableListStyle.ccExpandableListClose,
    'cc-ExpandableList__btn': ccExpandableListStyle.ccExpandableListBtn
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;